import { ActivatedRoute } from '@angular/router';
import { AuthBaseService } from './../../../services/auth/auth-base.service';
import { Token } from './../../../models/token.model';
import { LoginModalService } from '../../../services/auth/login-modal.service';
import { EScreenSize } from '../../../enums/screen-size.enum';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Component, Input, OnInit, HostListener } from '@angular/core';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

@Component({
  selector: 'app-cadastre-se-stripe',
  templateUrl: './cadastre-se-stripe.component.html',
  styleUrls: ['./cadastre-se-stripe.component.scss']
})
export class CadastreSeStripeComponent implements OnInit {
  @Input() isDynamic: boolean = false;
  @Input() title: string;
  screenSizeSubject: BehaviorSubject<EScreenSize> = new BehaviorSubject<EScreenSize>(EScreenSize.DESKTOP);

  initialScreenSize: EScreenSize = window.innerWidth >= 1920 ? EScreenSize.DESKTOP : EScreenSize.LAPTOP;
  currentScreenSize: EScreenSize;

  isColumn: boolean = false;

  currentLoggedUser: Token = new Token();

  currentLoggedUserSubscription: Subscription;
  routeParamsSubscription: Subscription;

  height: string;
  fontSizeButton: string = '5px';

  get EScreenSize() {
    return EScreenSize;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.currentScreenSize = window.innerWidth >= 1920 ? EScreenSize.DESKTOP : EScreenSize.LAPTOP;

    if (this.initialScreenSize !== this.currentScreenSize && this.isDynamic) {
      this.fixStripeSize(event.target.innerWidth)
    }

  }

  constructor(
    private loginModalService: LoginModalService,
    private authBaseService: AuthBaseService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.getLoggedUser();

    this.routeParamsSubscription = this.activatedRoute.params.subscribe((res) => {
      this.redimensionInit();
    })
  }

  redimensionInit(): void {
    setTimeout(() => {

      if (this.isDynamic) {
        this.fixStripeSize(window.innerWidth);

        this.screenSizeSubject.subscribe((res: EScreenSize) => {
          switch (true) {
            case res === EScreenSize.DESKTOP:
              this.redimensionContent(EScreenSize.DESKTOP);
              this.fontSizeButton = '46px';
              break;
            case res === EScreenSize.LAPTOP:
              this.redimensionContent(EScreenSize.LAPTOP);
              this.fontSizeButton = '34px';
              break;
          }
        })

      } else {
        this.fontSizeButton = null;
        this.redimensionFullWidth();
      }
    }, 1000);
  }

  fixStripeSize(innerWidth: number): void {
    let cadastrese = document.querySelector('.cadastre-se') as HTMLElement;
    let cadastreseStyle = getComputedStyle(cadastrese).width.replace('px', '');
    if (innerWidth >= 1920) {
      this.screenSizeSubject.next(EScreenSize.DESKTOP);
      this.height = '538px';
      this.initialScreenSize = EScreenSize.DESKTOP;
    } else {
      this.screenSizeSubject.next(EScreenSize.LAPTOP);
      if (innerWidth >= 1517) {
        this.height = '100%';
      } else {
        this.height = '365px';
      }
      this.initialScreenSize = EScreenSize.LAPTOP;
    }

  }

  redimensionContent(screenType: EScreenSize): void {
    let title = document.querySelector('.title2') as HTMLElement;
    let description = document.querySelector('.description2') as HTMLElement;
    let cadastrese = document.querySelector('.cadastre-se') as HTMLElement;

    let cadastreseStyle = getComputedStyle(cadastrese).width.replace('px', '');
    if (screenType === EScreenSize.DESKTOP) {
      title.style.fontSize = '59.28px';
      description.style.fontSize = '22px';
    } else {
      title.style.fontSize = '41px';
      description.style.fontSize = '13px';
    }

    switch (true) {
      case parseFloat(cadastreseStyle) >= window.innerWidth:
        this.isColumn = false;
        this.height = '100%';
        break;
      case parseFloat(cadastreseStyle) + 16 < window.innerWidth:
        this.isColumn = true;

        setTimeout(() => {
          let cadastreseUpdated = getComputedStyle(document.querySelector('.cadastre-se')).width.replace('px', '');
          if (screenType === EScreenSize.DESKTOP) {
            if (parseFloat(cadastreseUpdated) <= window.innerWidth / 4) {
              let title = document.querySelector('.title2') as HTMLElement;
              let description = document.querySelector('.description2') as HTMLElement;
              title.style.fontSize = '39px';
              description.style.fontSize = '20px';
            }
          }

          if (screenType === EScreenSize.LAPTOP) {
            if (parseFloat(cadastreseUpdated) <= window.innerWidth / 4) {
              let title = document.querySelector('.title2') as HTMLElement;
              let description = document.querySelector('.description2') as HTMLElement;
              title.style.fontSize = '30px';
              description.style.fontSize = '13px';
            }
          }
        }, 500);
        break;
      default:
        this.redimensionFullWidth();
        this.isColumn = false;
        break;
    }
  }

  redimensionFullWidth(): void {
    if(this.isDynamic){
      if (this.initialScreenSize === EScreenSize.DESKTOP) {
        this.height = '538px';
      }
  
      if (this.initialScreenSize === EScreenSize.LAPTOP) {
        this.height = '255px';
      }
    }
  }

  ngOnDestroy(): void {
    this.currentLoggedUserSubscription.unsubscribe();
    this.routeParamsSubscription.unsubscribe();
  }

  openSignupModal(): void {
    this.loginModalService.openModalSignUp();
  }

  getLoggedUser(): void {
    this.currentLoggedUserSubscription = this.authBaseService.watchUsuarioLogado().subscribe((res: Token) => {
      this.currentLoggedUser = res;
    })
  }
}
